import { UseData } from "@/hooks/useData";
import useQueries from "@/hooks/useQueries";
import { API_URL } from "@/shared/utils/API_URL";
import { buildQuery } from "@/shared/utils/buildQuery";
import { useMemo, useState, useEffect } from "react";
import { useParams } from "react-router-dom";

interface RemaningSerial {
    serial_string: string;
    remaning_quantity: string;
    checked?: boolean;
}

const useRemaningSerials = () => {
    const { id, name } = useParams();
    const queries = useQueries();
    const [serials, setSerials] = useState<RemaningSerial[]>([]);

    const remainingSerialsQuery = useMemo(() => {
        if (!queries?.itemSerialsQuery || !id) return '';
        return buildQuery(queries?.itemSerialsQuery, { id: id, });
    }, [queries, id])

    const { data, isLoading } = UseData({
        apiUrl: API_URL,
        q: remainingSerialsQuery,
        t: "sel",
        dependency: [id, remainingSerialsQuery],
    });

    const remainingSerials: RemaningSerial[] = data?.data?.result || [];


    useEffect(() => {
        if (data?.data?.result) {
            const formattedData = data.data.result.map((item: RemaningSerial) => ({
                ...item,
                checked: false
            }));
            setSerials(formattedData);

        }

    }, [data]);

    const toggleCheck = (serial_string: string) => {
        setSerials(prev => prev?.map(item =>
            item?.serial_string == serial_string
                ? { ...item, checked: !item?.checked }
                : item
        ))
    }

    const selectAll = () => {
        const isAllSelected = serials.every(s => s.checked);

        setSerials(prev => prev?.map(item => ({ ...item, checked: !isAllSelected })));
    }

    const handlePrint = () => {

        const selectedSerials = serials?.filter(s => s.checked);

        if (selectedSerials.length === 0) return;

        const targetOrigin = "https://w-lbl.ntelgnt.com";
        const url = `${targetOrigin}/print_serials?name=${encodeURIComponent(name || '')}&data=${true}`;

        const newWindow = window.open(url, '_blank');

        const messageListener = (event) => {
            if (event.origin !== targetOrigin) return;

            if (event.data === "READY_TO_PRINT") {
                newWindow.postMessage({
                    type: 'SERIALS_DATA',
                    payload: selectedSerials
                }, targetOrigin);

                window.removeEventListener('message', messageListener);
            }
        };
        window.addEventListener('message', messageListener);
    };

    return {
        name,
        isLoading,
        remainingSerials,
        remainingSerialsQuery,
        serials,
        selectAll,
        toggleCheck,
        handlePrint
    }
}

export default useRemaningSerials;